import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import TeethQuadrant from './TeethQuadrant';
import { FDI } from './nomenclatures';

export function TeethOdontoGram(
  {
    name,
    value = [],
    isChild = false,
    typeNomenclature = FDI,
    onChange = () => {
      return null;
    },
    disabled
  }
) {
  const [selectedTeeth, setSelectedTeeth] = useState(value || []);

  const handleSelectTooth = useCallback(
    (teeth) => {
      if (selectedTeeth.includes(teeth)) {
        const newSelected = selectedTeeth.filter((item) => item !== teeth);
        setSelectedTeeth(newSelected);
        onChange(newSelected);
      } else {
        const newSelected = [...selectedTeeth, teeth];
        setSelectedTeeth(newSelected);
        onChange(newSelected);
      }
    },
    [selectedTeeth, onChange]
  );
  return (
    [1, 2, 3, 4].map(quadrant => (
      <TeethQuadrant
        name={name}
        key={`quadrant-${quadrant}`}
        quadrantNumber={quadrant}
        isChild={isChild}
        typeNomenclature={typeNomenclature}
        selectedTeeth={selectedTeeth}
        handleSelectTooth={handleSelectTooth}
        disabled={disabled}
      />
    ))
  );
}

TeethOdontoGram.propTypes = {
  name: PropTypes.string,
  value: PropTypes.array,
  isChild: PropTypes.bool,
  typeNomenclature: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
export default TeethOdontoGram;
